const $ = jQuery;
$(document).ready(function(){

   //carousels
    const $arrowLeft = '<button type="button" class="slick-prev arrow-nav-btn"><svg xmlns="http://www.w3.org/2000/svg" width="8" height="14" fill="none" viewBox="0 0 8 14" class="sc-2a3e549a-1 bkqSOX"><path stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" d="m1 1 6 6-6 6"></path></svg></button>';
    const $arrowRight = '<button type="button" class="slick-next arrow-nav-btn"><svg xmlns="http://www.w3.org/2000/svg" width="8" height="14" fill="none" viewBox="0 0 8 14" class="sc-2a3e549a-1 bkqSOX"><path stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" d="m1 1 6 6-6 6"></path></svg></button>';

  // if ($('#partners-carousel').length) {
  //   var partnersCarousel = $('#partners-carousel');
  //   partnersCarousel.on('init', lazyLoad (partnersCarousel)); //prevent slides coming out of the carousel for a first moment
  //     $('#partners-carousel').slick({
  //       infinite: true,
  //       slidesToShow: 4,
  //       slidesToScroll: 1,
  //       dots: false,
  //       arrows: false,
  //       autoplay: true,
  //       autoplaySpeed: 2000,
  //       swipeToSlide: true,
  //       pauseOnHover: false
  //     });
  //   }

  // if ($('.images-carousel').length) {
  //   $('.images-carousel').slick({
  //     infinite: true,
  //     slidesToShow: 4,
  //     slidesToScroll: 1,
  //     dots: false,
  //     arrows: false,
  //     autoplay: true,
  //     autoplaySpeed: 2000,
  //     variableWidth: true,
  //     swipeToSlide: true,
  //     pauseOnHover: false
  //   });
  // }

  if ($('.amplitiv-carousel').length) {
    $('.amplitiv-carousel').slick({
      infinite: false,
      slidesToShow: 1,
      slidesToScroll: 1,
      autoplay: false,
      appendArrows: $('.amplitiv-carousel__navigation .amplitiv-carousel__arrows'),
      prevArrow: $arrowLeft,
      nextArrow: $arrowRight,
      dots: true,
      appendDots: $('.amplitiv-carousel__navigation'),
      autoplaySpeed: 2000,
      mobileFirst: true,
      responsive: [
        {
          breakpoint: 768,
          settings: {
            slidesToShow: 3,
          }
        },
      ]
    });
  }

  // if ($('#subpage-slider').length) {
  //   $('#subpage-slider').slick({
  //     infinite: false,
  //     slidesToShow: 1,
  //     slidesToScroll: 1,
  //     autoplay: true,
  //     appendArrows: $('#subpage-slider-navigation .subpage-slider__arrows'),
  //     prevArrow: $arrowLeft,
  //     nextArrow: $arrowRight,
  //     autoplaySpeed: 6000,
  //     mobileFirst: true,
  //     responsive: [
  //       {
  //         breakpoint: 768,
  //         settings: {
  //           dots: true,
  //           appendDots: $('#subpage-slider-navigation'),
  //         }
  //       },
  //     ]
  //   });
  // }

    // $('#testimonials-carousel').slick({
    //   infinite: true,
    //   slidesToShow: 1,
    //   slidesToScroll: 1,
    //   autoplay: true,
    //   arrows: false,
    //   autoplaySpeed: 2000,
    //   mobileFirst: true,
    //   responsive: [
    //     {
    //       breakpoint: 768,
    //       settings: {
    //         slidesToShow: 2,
    //         arrows: true,
    //         dots: true,
    //         appendDots: $('#testimonials-navigation'),
    //         appendArrows: $('#testimonials-navigation .testimonials__arrows'),
    //         prevArrow: $arrowLeft,
    //         nextArrow: $arrowRight,
    //       }
    //     },
    //   ]
    // });

    if ($('.people-slider').length) {
      var peopleSlider = $('.people-slider');
      peopleSlider.on('init', lazyLoad (peopleSlider)); //prevent slides coming out of the carousel for a first moment
      peopleSlider.slick({
        infinite: true,
        slidesToShow: 1,
        slidesToScroll: 1,
        arrows: false,
        dots: true,
        autoplay: true,
        autoplaySpeed: 7500,
        dotsClass: 'people-slider__nav'
      });
    }
    if ($('#subpage-tiles-slider').length) {
      if ($(window).width() < 992) {
        $('#subpage-tiles-slider').slick({
          infinite: false,
          slidesToShow: 1,
          slidesToScroll: 1,
          appendArrows: $('#subpage-tiles-slider-navigation .subpage-tiles-slider__arrows'),
          prevArrow: $arrowLeft,
          nextArrow: $arrowRight,
          autoplay: true,
          autoplaySpeed: 9000
        });
      }
    }
    if ($('#timeline-slider').length) {
        var timelineSlider = $('#timeline-slider');
        timelineSlider.on('init', lazyLoad (timelineSlider)); //prevent slides coming out of the carousel for a first moment
        $('.timeline-slider__scroll-mask').on("click", function(){
            // timelineSlider.on('init', () =>
            if ($(window).width() > 992) {
              $('.timeline-slider__scroll-mask').fadeOut('fast');
              mouseWheel(timelineSlider)
              timelineSlider.removeClass('scroll-off');
            }
            // })
        });
        $('.timeline-slider__scroll-mask').on('wheel', function(){
          if ($(window).width() > 992) {
            $(this).css('opacity', '1');
          }
        });
        $('.timeline-slider__scroll-mask').mouseleave(function(){
          if ($(window).width() > 992) {
            $(this).css('opacity', '0');
          }
        });
        // if ($(window).width() > 992) {
        //   timelineSlider.on('init', () => {
        // 		mouseWheel(timelineSlider)
        // 	})
        // }
        timelineSlider.slick({
          infinite: true,
          slidesToShow: 1,
          slidesToScroll: 1,
          arrows: false,
          // appendDots: $('#subpage-slider-navigation'),
          // appendArrows: $('#subpage-slider-navigation .subpage-slider__arrows'),
          prevArrow: $arrowLeft,
          nextArrow: $arrowRight,
          // autoplay: true,
          // autoplaySpeed: 9000,
          dots: true,
          customPaging: function(slider, i) {
            switch(i) {
             case 0:
              return '<button class="timeline-slider__tab btn-style-none">' + '2022' + '</button>';
              break;
             case 1:
              return '<button class="timeline-slider__tab btn-style-none">' + '2021' + '</button>';
              break;
             case 2:
              return '<button class="timeline-slider__tab btn-style-none">' + '2015' + '</button>';
              break;
             case 3:
              return '<button class="timeline-slider__tab btn-style-none">' + '2007' + '</button>';
              break;
             case 4:
              return '<button class="timeline-slider__tab btn-style-none">' + '2001' + '</button>';
              break;
             default:
              return '<button class="timeline-slider__tab btn-style-none">' + '2000' + '</button>';
            }
          },
          appendDots: $('#timeline-slider-navigation'),
          mobileFirst: true,
          responsive: [
            {
              breakpoint: 992,
              settings: {
                vertical: true,
              }
            },
          ]
        });
    }

    // show carousel when loaded
    function lazyLoad(carousel) {
      carousel.css({visibility: 'visible'});
    };

    // slider on scroll
    function mouseWheel($slider) {
      $($slider).on('wheel', { $slider: $slider }, mouseWheelHandler)
    }
    function mouseWheelHandler(event) {
      event.preventDefault()
      const $slider = event.data.$slider
      const delta = event.originalEvent.deltaY
      if(delta > 0) {
        $slider.slick('slickNext')
      }
      else {
        $slider.slick('slickPrev')
      }
    }


});
